/**
 * Whether the address is the agency's dossier link (`/dossier/:token`, from
 * its email) — a public page made for any screen: the agency may open it on a
 * phone, where Citizen Web otherwise sends people to the app.
 */
export function agencyDossierInAddress(): boolean {
  return /^\/dossier\/[^/]+\/?$/.test(window.location.pathname);
}
